const ns = "EVENT_EMAIL_MERGE_TAGS";
export const RECEIVE = `${ns}_RECEIVE`;
export const RECEIVE_PREVIEWS = `${ns}_RECEIVE_PREVIEWS`;
export const REQUEST = `${ns}_REQUEST`;
